import React, { Component } from 'react';

import './HealthFilter.css';

export default class HealthFilter extends Component {
  render() {
    return (
      <div
        className={`HealthFilter ${this.props.name} ${this.props.disabled ? 'disabled' : this.props.selected ? 'selected' : ''} `}
        style={this.props.style}
        onClick={this.props.onClick}
        selected={this.props.selected}
      >
        <div className="inner">
          <div className="item">
            <div className="circle">{this.props.icon}</div>
            <div>
              <div className="value">{this.props.number}</div>
              <div className="label">{this.props.label}</div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/App/ClientListWithMap/HealthsFilter/HealthFilter/HealthFilter.js